import {
  ACTION_DELETE_SEO_TRANSLATIONS__REQUEST,
  ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS,
  ACTION_DELETE_SEO_TRANSLATIONS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SEO_TRANSLATIONS__REQUEST:
    case ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS:
      return null;

    case ACTION_DELETE_SEO_TRANSLATIONS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
